import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getBiomarkerList = (payload: any) => {
    return ApiService[APIConfig.GET_BIOMARKER_LIST.METHOD](APIConfig.GET_BIOMARKER_LIST.URL, payload);
}

const toggleBiomarker = (biomarkerId: any) =>{
    return ApiService[APIConfig.TOGGLE_BIOMARKER_STATUS.METHOD](APIConfig.TOGGLE_BIOMARKER_STATUS.URL(biomarkerId), {});
}

const addBiomarker = (payload: any) => {
    return ApiService[APIConfig.ADD_BIOMARKER.METHOD](APIConfig.ADD_BIOMARKER.URL, payload);
}

const updateBiomarker = (payload: any,bioMarkerId:any) => {
    return ApiService[APIConfig.UPDATE_BIOMARKER.METHOD](APIConfig.UPDATE_BIOMARKER.URL(bioMarkerId), payload);
}

const addConfiguration = (payload: any,biomarkerId:any) => {
    return ApiService[APIConfig.ADD_CONFIGURATION.METHOD](APIConfig.ADD_CONFIGURATION.URL(biomarkerId), payload);
}

const updateConfiguration = (payload: any,biomarkerId:any,configId:any) => {
    return ApiService[APIConfig.UPDATE_CONFIGURATION.METHOD](APIConfig.UPDATE_CONFIGURATION.URL(biomarkerId,configId), payload);
}

const getBiomarkerDetails = (biomarkerId:any,payload:any) => {
    return ApiService[APIConfig.GET_BIOMARKER_DETAILS.METHOD](APIConfig.GET_BIOMARKER_DETAILS.URL(biomarkerId), payload);
}

const getBiomarkerAttachmentList = (biomarkerId:any,payload:any) => {
    return ApiService[APIConfig.GET_BIOMARKER_ATTACHMENT_LIST.METHOD](APIConfig.GET_BIOMARKER_ATTACHMENT_LIST.URL(biomarkerId), payload);
}

const addBiomarkerAttachment = (biomarkerId:any,payload:any) => {
    return ApiService[APIConfig.ADD_BIOMARKER_ATTACHMENT.METHOD](APIConfig.ADD_BIOMARKER_ATTACHMENT.URL(biomarkerId), payload);
}

const deleteBiomarkerAttachment = (biomarkerId:any,attachmentId:any) => {
    return ApiService[APIConfig.DELETE_BIOMARKER_ATTACHMENT.METHOD](APIConfig.DELETE_BIOMARKER_ATTACHMENT.URL(biomarkerId,attachmentId));
}

const getBiomarkerConfigurations = (biomarkerId:any,payload:any) => {
    return ApiService[APIConfig.GET_BIOMARKER_CONFIGURATION_LIST.METHOD](APIConfig.GET_BIOMARKER_CONFIGURATION_LIST.URL(biomarkerId), payload);
}

const editReportConfiguration = (configId:any,payload:any) => {
    return ApiService[APIConfig.EDIT_BIOMARKER_CONFIGURATION.METHOD](APIConfig.EDIT_BIOMARKER_CONFIGURATION.URL(configId), payload);
}

const downloadBiomarkerCsv = (payload:any) => {
    return ApiService[APIConfig.DOWNLOAD_BIOMARKER_CSV.METHOD](APIConfig.DOWNLOAD_BIOMARKER_CSV.URL,payload);
}
const uploadBulkBiomarker=(payload:any)=>{
    return ApiService[APIConfig.UPLOAD_BULK_BIOMARKER.METHOD](APIConfig.UPLOAD_BULK_BIOMARKER.URL, payload);
}
const downloadBulkBiomarkerTemplate=()=>{
    return ApiService[APIConfig.DOWNLOAD_BULK_BIOMARKER_TEMPLATE.METHOD](APIConfig.DOWNLOAD_BULK_BIOMARKER_TEMPLATE.URL);
}
const BiomarkerService = {
    getBiomarkerList,
    toggleBiomarker,
    addBiomarker,
    updateBiomarker,
    addConfiguration,
    getBiomarkerDetails,
    updateConfiguration,
    getBiomarkerAttachmentList,
    addBiomarkerAttachment,
    deleteBiomarkerAttachment,
    getBiomarkerConfigurations,
    editReportConfiguration,
    downloadBiomarkerCsv,
    uploadBulkBiomarker,
    downloadBulkBiomarkerTemplate,
}

export default BiomarkerService;
